import React, { useEffect, useState } from "react";
import moment from "moment";
import axios from "../../../config/axiosConfig";
import { useDispatch, useSelector } from "react-redux";

import ButtonName from "../../../MockData/ButtonName.json";
import { Appointments } from "./Appointments";
import { OnGoingAppointment } from "./OnGoingAppointment";
import { CancelledAppointment } from "./CancelledAppointment";
import { CompletedAppointment } from "./CompletedAppointment";

import AllTabs from "../../../Component/UI/Tabs/AllTabs";
import Text_Seach_Filter_Export from "../../../Hooks/Text_Seach_Filter_Export";
import { usePermissions } from "../../../Hooks/usePermissions";
import { resetSearchFilters } from "../../../Redux/Slices/AdminFilters/Search";

export const Appointmentss = () => {
  const dispatch = useDispatch();
  const permissions = usePermissions("name", "appointments");
  const btnApi = ButtonName.Appointments;
const defaultTab = Object.keys(btnApi[0])[0];
const [tabID, selectedTabID] = useState(defaultTab);
  const [upcomingData, setUpcomingData] = useState();
  const [OnGoingData, setOnGoingData] = useState();
  const [CancelledData, setCancelledData] = useState();
  const [CompletedData, setCompletedData] = useState();
  const { search_key, from_date, to_date } = useSelector(
    (state) => state.SearchFilters,
  );
  useEffect(() => {
    return () => {
      dispatch(resetSearchFilters());
    };
  }, []);

const formatAppointmentData = (list = [], type) => {
  return list.map((el) => {
    const common = {
      Date: moment(el.appointment_date).format("DD-MM-YYYY"),
      "Session Id": el.session_id,
      "Patient Name": el.paitient_name,
      "Service Name": el.service_name,
      Mobile: el.mobile,
      "Start Time": el.appointment_time,
      "End Time": el.end_time,
    };

    switch (type) {
      case "Upcoming":
        return {
          ...common,
          Status: el.status === 1 ? "Active" : "Inactive",
        };

      case "onGoing":
        return {
          ...common,
          Staff: el.staff,
          Status: el.status === 1 ? "Active" : "Inactive",
        };

      case "Cancelled":
        return {
          ...common,
          Staff: el.staff,
          "Cancel Date": el.updated_at
            ? moment(el.updated_at).format("DD-MM-YYYY")
            : "",
          Status: "Cancelled",
        };

      case "Completed":
        return {
          ...common,
          Staff: el.staff,
          "Started At": el.appointment_start_date
            ? moment(el.appointment_start_date).format("hh:mm:ss A")
            : "",
          "Completed At": el.appointment_end_date
            ? moment(el.appointment_end_date).format("hh:mm:ss A")
            : "",
        };

      default:
        return common;
    }
  });
};


  const ComponentName = [
    <Appointments
      tabID={tabID}
      setUpcomingData={setUpcomingData}
      permissions={permissions}
    />,
    <OnGoingAppointment
      tabID={tabID}
      setOnGoingData={setOnGoingData}
      permissions={permissions}
    />,
    <CancelledAppointment
      tabID={tabID}
      setCancelledData={setCancelledData}
      permissions={permissions}
    />,
    <CompletedAppointment
      tabID={tabID}
      setCompletedData={setCompletedData}
      permissions={permissions}
    />,
  ];

const handleAppointmentExport = async () => {
  try {
    const typeMap = {
      Upcoming: "upcoming",
      onGoing: "ongoing",
      Cancelled: "cancelled",
      Completed: "completed",
    };

    const type = typeMap[tabID] || "upcoming";

    const { data } = await axios.get(
      `/admin/get/appointmentNew`,
      {
        params: {
          type,
          page: 1,
          search_key,
          fromdate: from_date !== "Invalid date" ? from_date : "",
          todate: to_date !== "Invalid date" ? to_date : "",
          is_export: 1,
        },
      }
    );

    return formatAppointmentData(data.list || [], tabID);
  } catch (error) {
    console.error(error);
    return [];
  }
};

const obj = {
  Upcoming: formatAppointmentData(upcomingData, "Upcoming"),
  onGoing: formatAppointmentData(OnGoingData, "onGoing"),
  Cancelled: formatAppointmentData(CancelledData, "Cancelled"),
  Completed: formatAppointmentData(CompletedData, "Completed"),
};

  return (
    <>
      <Text_Seach_Filter_Export
        text={"Appointments"}
        ApiData={obj[tabID]}
        route="/add_appointments"
        searchText="Search for appointment"
        permissions={permissions?.listControl}
        appointment={true}
        onExport={handleAppointmentExport}
        // defaultStart={defaultStart}
        // defaultEnd={defaultEnd}
      >
        <AllTabs
          ComponentName={ComponentName}
          btnApi={btnApi}
          selectedTabID={selectedTabID}
        />
      </Text_Seach_Filter_Export>
    </>
  );
};
